import React from 'react'
import { IconButton, makeStyles, TextField } from '@material-ui/core'

import { useHotkeys } from 'react-hotkeys-hook'

const useStyles = makeStyles((theme) => ({
}))

const SmartIconButton = (props: {
	keyName: string,
	onClick: (e: any) => void,
	className: any,
	children: any
}) => {

	const {
		keyName,
		onClick,
		className,
		children
	} = props

	const classes = useStyles()

	// filter: to fix useHotkeys not having a memoizedCallback updating when callback is changing (filter is updating the useCallback.....)
	useHotkeys(keyName, onClick, { keyup: true, enableOnContentEditable: true, filter: (e: any) => true })

	return (
		<IconButton onClick={onClick} className={className} edge="start" color="inherit" /* aria-label="play audio "*/>
			{children}
		</IconButton>
	)
}

export default SmartIconButton
